import { render } from "./SelectInventory.vue?vue&type=template&id=13806da9"
import script from "./SelectInventory.vue?vue&type=script&lang=js"
export * from "./SelectInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__